<div *ngIf="isShowList" class="row records-list">
  <div class="col-xs-12">
    <ul class="list-unstyled">
      <li *ngFor="let proposta of propostas">
        <span class="status recusada" [ngClass]="{'recusada': isRecusada(proposta),'analise': isAnalise(proposta),'analisedireta': isAnaliseDireta(proposta),'aprovada': isAprovada(proposta),'contrato': isContrato(proposta)}"></span>
        <a (click)="goToTimeline(proposta)" class="name" title="Clique para ver mais detalhes da ficha">
          {{proposta.nomeCliente}} | {{proposta.cpfCliente | cpf}}
          <small>{{proposta.idProposta}} - {{proposta.statusProposta}}</small>
        </a>
      </li>
    </ul>
  </div>
</div>
